import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DetailedItemProps as Props } from './types';
import { PeopleDetail } from '../people-detail';
import { CompanyDetail } from '../company-detail';
import { useSuggestionSearchBarContext } from '../../context';
import { SearchCategory } from '../../types';

const DetailComponents: Record<SearchCategory, React.FC> = {
  people: PeopleDetail,
  company: CompanyDetail,
};

export const DetailedItem = memo(({ className }: Props) => {
  const { searchCategory } = useSuggestionSearchBarContext();

  const Component = DetailComponents[searchCategory as SearchCategory];

  return (
    <Styled.Wrapper
      className={classnames('DetailedItem', className)}
      sx={SX.root}
    >
      {Component && <Component />}
    </Styled.Wrapper>
  );
});

DetailedItem.displayName = 'DetailedItem';
